import { createGlobalStyle, css } from 'styled-components';

const ForgotPasswordPopupStyle = createGlobalStyle`${css`
	:root {
		--forgotDescriptionMargin: var(--sp4x) auto var(--sp8x);
		--forgotDescriptionMaxWidth: var(--sp86x);
		--sendEmailButtonMargin: var(--sp8x) 0;
		--forgotContentWrapPadding: 0 var(--sp18x);
	}

	.popup-content-container {
		width: fit-content !important;
	}

	.forgot-content-wrap {
		padding: var(--forgotContentWrapPadding);
		margin: 0 auto;

		.success-message {
			margin-bottom: var(--sp1x);
		}

		.forgot-title {
			text-align: center;
		}

		.forgot-description {
			text-align: center;
			margin: var(--forgotDescriptionMargin);
			max-width: var(--forgotDescriptionMaxWidth);
		}
	}

	.forgot-buttons-wrap {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin: var(--sendEmailButtonMargin);
	}

	.sign-in {
		cursor: pointer;
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeL}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXLMin}) {
		:root {
			--forgotDescriptionMargin: var(--sp4x) 0 var(--sp5x) 0;
			--sendEmailButtonMargin: var(--sp6x) 0;
			--forgotDescriptionMaxWidth: var(--sp64x);
			--forgotContentWrapPadding: 0 var(--sp12x);
		}
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeM}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeLMin}) {
		:root {
			--forgotDescriptionMargin: var(--sp3x) 0 var(--sp5x) 0;
			--sendEmailButtonMargin: var(--sp5x) 0;
			--forgotDescriptionMaxWidth: var(--sp50x);
			--forgotContentWrapPadding: 0 var(--sp10x);
		}
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeS}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeMMin}) {
		:root {
			--forgotDescriptionMargin: var(--sp3x) 0 var(--sp5x) 0;
			--sendEmailButtonMargin: var(--sp5x) 0;
			--forgotDescriptionMaxWidth: var(--sp48x);
			--forgotContentWrapPadding: 0 var(--sp10x);
		}
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXS}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeSMin}) {
		:root {
			--forgotDescriptionMargin: var(--sp3x) 0 var(--sp4x) 0;
			--sendEmailButtonMargin: var(--sp5x) 0;
			--forgotDescriptionMaxWidth: var(--sp51x);
			--forgotContentWrapPadding: 0 var(--sp7x);
		}
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.TabletSize}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXSMin}) {
		:root {
			--forgotDescriptionMargin: var(--sp3x) 0 var(--sp4x) 0;
			--sendEmailButtonMargin: var(--sp4x) 0;
			--forgotDescriptionMaxWidth: var(--sp44x);
			--forgotContentWrapPadding: 0 var(--sp5x);
		}
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.TabletSizeS}) and (max-width: ${({ theme }) => theme.mediaQuery.TabletSizeMin}) {
		:root {
			--forgotDescriptionMargin: var(--sp3x) 0 var(--sp4x) 0;
			--sendEmailButtonMargin: var(--sp4x) 0;
			--forgotDescriptionMaxWidth: 100%;
			--forgotContentWrapPadding: 0 var(--sp5x);
		}
	}

	@media (max-width: ${({ theme }) => theme.mediaQuery.TabletSizeSMin}) {
		:root {
			--forgotDescriptionMargin: var(--sp3x) 0 var(--sp4x) 0;
			--sendEmailButtonMargin: var(--sp4x) 0;
			--forgotDescriptionMaxWidth: 100%;
			--forgotContentWrapPadding: 0;
		}

		.popup-content-container {
			max-width: calc(100% - 32px) !important;
		}
	}
`}`;

export default ForgotPasswordPopupStyle;
